export interface IRouteLink {
    route: () => string;
    title: string;
    icon: string;
    actived: boolean;
}
